"use strict";
// tslint:disable
/**
 * Workflow service API
 * This service's responsibility is to get, create, modify, and run workflows
 *
 * OpenAPI spec version: 2017-09-01
 * Contact: cloudlink.support@mitel.io
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually. Blah blah blah
 */
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const URLSearchParams = require('url-search-params');
const config_1 = require("../config");
const notifications_1 = require("../notifications");
const utils_1 = require("../utils");
const service_requester_1 = require("../service-requester");
// @ts-ignore
const separators = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|',
};
/**
 * WorkflowService
 * @class
 */
class WorkflowService {
    /**
     * @constructor
     */
    constructor(params = {}) {
        this.topicFocusedNotify = new notifications_1.TopicFocusedNotify({
            notify: params.notify || config_1.Config.notifications,
            topic: 'platform-api-workflow',
        });
        this.serviceRequester = params.serviceRequester || new service_requester_1.ServiceRequester(Object.assign({ service: 'Workflow' }, params));
    }
    notifications() {
        return this.topicFocusedNotify;
    }
    /**
    * Creates activity in the account
    * @summary Create Activity
    * @param {ActivityPostRequest} body Request body
    * @throws {RequiredError}
    */
    createActivity(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createActivity.');
        }
        const path = `/activities`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete an activity document by its id
    * @summary Delete an activity by its Id
    * @param {string} activityId
    * @throws {RequiredError}
    */
    deleteActivityById(params) {
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling deleteActivityById.');
        }
        const path = `/activities/{activityId}`
            .replace(`{${'activityId'}}`, String(params.activityId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides a list of activities in your account
    * @summary Get activities for your account
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @param {string} [items] Batch request of items by their keys (maximum 100) concatenated in comma separated format  Example: ?items&#x3D;key1,key2,key3
    * @param {string} [$Search] text based search
    * @param {string} [$Orderby] Determines the order in which items are returned based on a provided property and sort order (&#39;desc&#39; for descending or &#39;asc&#39; for ascending). Currently only supports sorting on the &#39;createdOn&#39; property.  Example: ?$orderby&#x3D;createdOn desc
    * @throws {RequiredError}
    */
    getActivities(params) {
        const path = `/activities`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets all activities that have the associated tag
    * @param {string} tagId
    * @throws {RequiredError}
    */
    getActivitiesByTag(params) {
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling getActivitiesByTag.');
        }
        const path = `/activities/tags/{tagId}`
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the activity document that is used at runtime
    * @summary Get an activity by its Id
    * @param {string} activityId
    * @param {boolean} [designer]
    * @param {string} [version]
    * @throws {RequiredError}
    */
    getActivityById(params) {
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling getActivityById.');
        }
        const path = `/activities/{activityId}`
            .replace(`{${'activityId'}}`, String(params.activityId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.designer !== undefined) {
            query['designer'] = params.designer;
        }
        if (params.version !== undefined) {
            query['version'] = params.version;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides statistics information about an activity
    * @summary Get statistics for an activity by its Id
    * @param {string} activityId
    * @throws {RequiredError}
    */
    getActivityStatisticsById(params) {
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling getActivityStatisticsById.');
        }
        const path = `/activities/{activityId}/statistics`
            .replace(`{${'activityId'}}`, String(params.activityId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get all tags associated with activity
    * @param {string} activityId
    * @throws {RequiredError}
    */
    getActivityTags(params) {
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling getActivityTags.');
        }
        const path = `/activities/{activityId}/tags`
            .replace(`{${'activityId'}}`, String(params.activityId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides access to running workers for a given activity id. Returns a list of running workers
    * @summary Get running workers for an activity
    * @param {string} activityId
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @param {string} [$Search] text based search
    * @throws {RequiredError}
    */
    getWorkersByActivityId(params) {
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling getWorkersByActivityId.');
        }
        const path = `/activities/{activityId}/workers`
            .replace(`{${'activityId'}}`, String(params.activityId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Associate activity with tag
    * @param {string} activityId
    * @param {string} tagId
    * @throws {RequiredError}
    */
    removeActivityTag(params) {
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling removeActivityTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling removeActivityTag.');
        }
        const path = `/activities/{activityId}/tags/{tagId}`
            .replace(`{${'activityId'}}`, String(params.activityId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Run an activity by creating a worker
    * @summary Runs a worker by an activity Id
    * @param {string} activityId
    * @param {WorkerPostRequest} body Worker post request object
    * @throws {RequiredError}
    */
    runWorkerByActivityId(params) {
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling runWorkerByActivityId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling runWorkerByActivityId.');
        }
        const path = `/activities/{activityId}/workers`
            .replace(`{${'activityId'}}`, String(params.activityId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates an activity document by its identifier
    * @summary Update an activity attributes by its ID. This is used for partial updats
    * @param {string} activityId
    * @param {ActivityPatchRequest} body
    * @throws {RequiredError}
    */
    updateActivityAttributesById(params) {
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling updateActivityAttributesById.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateActivityAttributesById.');
        }
        const path = `/activities/{activityId}`
            .replace(`{${'activityId'}}`, String(params.activityId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PATCH', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the full activity document by its identifier
    * @summary Update an activity by its ID. Used as a full replacement
    * @param {string} activityId
    * @param {ActivityPutRequest} body Activity PUT request object
    * @param {boolean} [debug]
    * @throws {RequiredError}
    */
    updateActivityById(params) {
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling updateActivityById.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateActivityById.');
        }
        const path = `/activities/{activityId}`
            .replace(`{${'activityId'}}`, String(params.activityId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.debug !== undefined) {
            query['debug'] = params.debug;
        }
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Associate activity with tag(s)
    * @param {string} activityId
    * @param {TagActivityPostRequest} body Tag PUT request object
    * @throws {RequiredError}
    */
    updateActivityTags(params) {
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling updateActivityTags.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateActivityTags.');
        }
        const path = `/activities/{activityId}/tags`
            .replace(`{${'activityId'}}`, String(params.activityId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Validates activity in the account
    * @summary Validates Activity
    * @param {string} activityId
    * @throws {RequiredError}
    */
    validateActivity(params) {
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling validateActivity.');
        }
        const path = `/activities/{activityId}`
            .replace(`{${'activityId'}}`, String(params.activityId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get insights about how workflow is being used in the account
    * @summary Get insight information for a specific insight id
    * @param {string} insightId The insightId being requested  Available insights are top-users, top-workflows, top-run-activities, longest-total-running-workflows and longest-average-running-workflows&#39;
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @throws {RequiredError}
    */
    getInsightById(params) {
        // verify required parameter 'insightId' is not null or undefined
        if (params.insightId === null || params.insightId === undefined) {
            throw new utils_1.RequiredError('insightId', 'Required parameter insightId was null or undefined when calling getInsightById.');
        }
        const path = `/insights/{insightId}`
            .replace(`{${'insightId'}}`, String(params.insightId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get supported insight types
    * @summary Get supported insight types
    * @throws {RequiredError}
    */
    getInsightTypes(params) {
        const path = `/insights`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get a third party integration by its id
    * @param {string} integrationId
    * @throws {RequiredError}
    */
    getIntegrationByIntegrationId(params) {
        // verify required parameter 'integrationId' is not null or undefined
        if (params.integrationId === null || params.integrationId === undefined) {
            throw new utils_1.RequiredError('integrationId', 'Required parameter integrationId was null or undefined when calling getIntegrationByIntegrationId.');
        }
        const path = `/integrations/{integrationId}`
            .replace(`{${'integrationId'}}`, String(params.integrationId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create an new integration connection to a third party
    * @summary Create an integration connection
    * @param {string} integrationId
    * @param {IntegrationConnectionPostRequest} body Worker post request object
    * @throws {RequiredError}
    */
    createIntegrationConnection(params) {
        // verify required parameter 'integrationId' is not null or undefined
        if (params.integrationId === null || params.integrationId === undefined) {
            throw new utils_1.RequiredError('integrationId', 'Required parameter integrationId was null or undefined when calling createIntegrationConnection.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createIntegrationConnection.');
        }
        const path = `/integrations/{integrationId}/connections`
            .replace(`{${'integrationId'}}`, String(params.integrationId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete a connection to an integration
    * @summary Delete a connection to an integration
    * @param {string} integrationId
    * @param {string} connectionId
    * @throws {RequiredError}
    */
    deleteIntegrationConnection(params) {
        // verify required parameter 'integrationId' is not null or undefined
        if (params.integrationId === null || params.integrationId === undefined) {
            throw new utils_1.RequiredError('integrationId', 'Required parameter integrationId was null or undefined when calling deleteIntegrationConnection.');
        }
        // verify required parameter 'connectionId' is not null or undefined
        if (params.connectionId === null || params.connectionId === undefined) {
            throw new utils_1.RequiredError('connectionId', 'Required parameter connectionId was null or undefined when calling deleteIntegrationConnection.');
        }
        const path = `/integrations/{integrationId}/connections/{connectionId}`
            .replace(`{${'integrationId'}}`, String(params.integrationId))
            .replace(`{${'connectionId'}}`, String(params.connectionId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides access to a connection to an integration
    * @summary Get an instance of a connection to an integration
    * @param {string} integrationId
    * @param {string} connectionId
    * @throws {RequiredError}
    */
    getIntegrationConnection(params) {
        // verify required parameter 'integrationId' is not null or undefined
        if (params.integrationId === null || params.integrationId === undefined) {
            throw new utils_1.RequiredError('integrationId', 'Required parameter integrationId was null or undefined when calling getIntegrationConnection.');
        }
        // verify required parameter 'connectionId' is not null or undefined
        if (params.connectionId === null || params.connectionId === undefined) {
            throw new utils_1.RequiredError('connectionId', 'Required parameter connectionId was null or undefined when calling getIntegrationConnection.');
        }
        const path = `/integrations/{integrationId}/connections/{connectionId}`
            .replace(`{${'integrationId'}}`, String(params.integrationId))
            .replace(`{${'connectionId'}}`, String(params.connectionId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Primarily used for UI lookups and dropdown lists. Proxy a url to the provider and return the providers resource
    * @summary Get a resource from a connection by proxying to the provider URL
    * @param {string} integrationId
    * @param {string} connectionId The explicit connection id OR * OR any to select the first connection for this integration
    * @param {string} url The url of the request to proxy through to the provider
    * @throws {RequiredError}
    */
    getIntegrationConnectionByIdProxyResource(params) {
        // verify required parameter 'integrationId' is not null or undefined
        if (params.integrationId === null || params.integrationId === undefined) {
            throw new utils_1.RequiredError('integrationId', 'Required parameter integrationId was null or undefined when calling getIntegrationConnectionByIdProxyResource.');
        }
        // verify required parameter 'connectionId' is not null or undefined
        if (params.connectionId === null || params.connectionId === undefined) {
            throw new utils_1.RequiredError('connectionId', 'Required parameter connectionId was null or undefined when calling getIntegrationConnectionByIdProxyResource.');
        }
        // verify required parameter 'url' is not null or undefined
        if (params.url === null || params.url === undefined) {
            throw new utils_1.RequiredError('url', 'Required parameter url was null or undefined when calling getIntegrationConnectionByIdProxyResource.');
        }
        const path = `/integrations/{integrationId}/connections/{connectionId}/proxy`
            .replace(`{${'integrationId'}}`, String(params.integrationId))
            .replace(`{${'connectionId'}}`, String(params.connectionId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.url !== undefined) {
            query['url'] = params.url;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * All existing connections
    * @summary Get all existing integration connections
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @param {string} [$Search] text based search
    * @throws {RequiredError}
    */
    getIntegrationConnections(params) {
        const path = `/integrations/connections`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides access to a list of connections to this integration
    * @summary Get all connections to the specified integration
    * @param {string} integrationId
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @throws {RequiredError}
    */
    getIntegrationConnectionsByIntegrationId(params) {
        // verify required parameter 'integrationId' is not null or undefined
        if (params.integrationId === null || params.integrationId === undefined) {
            throw new utils_1.RequiredError('integrationId', 'Required parameter integrationId was null or undefined when calling getIntegrationConnectionsByIntegrationId.');
        }
        const path = `/integrations/{integrationId}/connections`
            .replace(`{${'integrationId'}}`, String(params.integrationId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * This route triggers a 302 redirect back to the registered client_redirect_uri if specified.
    * @summary This route is used by third party call backs for Oauth2 authorization code flow. Not to be called directly by client applications
    * @param {string} integrationId
    * @throws {RequiredError}
    */
    getIntegrationSSOSigninByIntegrationId(params) {
        // verify required parameter 'integrationId' is not null or undefined
        if (params.integrationId === null || params.integrationId === undefined) {
            throw new utils_1.RequiredError('integrationId', 'Required parameter integrationId was null or undefined when calling getIntegrationSSOSigninByIntegrationId.');
        }
        const path = `/integrations/{integrationId}/sso`
            .replace(`{${'integrationId'}}`, String(params.integrationId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides a list of all third party integrations
    * @summary Get available integrations with third party SaaS services
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @param {string} [$Search] text based search
    * @throws {RequiredError}
    */
    getIntegrations(params) {
        const path = `/integrations`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * This will force a connection to be refreshed if the connection type supports this.
    * @summary Execute a refresh operation on a connection
    * @param {string} integrationId
    * @param {string} connectionId
    * @param {IntegrationRefreshRequest} body
    * @throws {RequiredError}
    */
    refreshIntegrationConnection(params) {
        // verify required parameter 'integrationId' is not null or undefined
        if (params.integrationId === null || params.integrationId === undefined) {
            throw new utils_1.RequiredError('integrationId', 'Required parameter integrationId was null or undefined when calling refreshIntegrationConnection.');
        }
        // verify required parameter 'connectionId' is not null or undefined
        if (params.connectionId === null || params.connectionId === undefined) {
            throw new utils_1.RequiredError('connectionId', 'Required parameter connectionId was null or undefined when calling refreshIntegrationConnection.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling refreshIntegrationConnection.');
        }
        const path = `/integrations/{integrationId}/connections/{connectionId}`
            .replace(`{${'integrationId'}}`, String(params.integrationId))
            .replace(`{${'connectionId'}}`, String(params.connectionId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update a connection to an integration
    * @summary Updates a connection to an integration
    * @param {string} integrationId
    * @param {string} connectionId
    * @param {IntegrationConnectionPutRequest} body
    * @throws {RequiredError}
    */
    updateIntegrationConnection(params) {
        // verify required parameter 'integrationId' is not null or undefined
        if (params.integrationId === null || params.integrationId === undefined) {
            throw new utils_1.RequiredError('integrationId', 'Required parameter integrationId was null or undefined when calling updateIntegrationConnection.');
        }
        // verify required parameter 'connectionId' is not null or undefined
        if (params.connectionId === null || params.connectionId === undefined) {
            throw new utils_1.RequiredError('connectionId', 'Required parameter connectionId was null or undefined when calling updateIntegrationConnection.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateIntegrationConnection.');
        }
        const path = `/integrations/{integrationId}/connections/{connectionId}`
            .replace(`{${'integrationId'}}`, String(params.integrationId))
            .replace(`{${'connectionId'}}`, String(params.connectionId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides this specification defining the resources of the API
    * @summary Get API spec
    * @throws {RequiredError}
    */
    getSpec(params) {
        const path = `/_spec`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the current status of this micro
    * @summary Get Status
    * @throws {RequiredError}
    */
    getStatus(params) {
        const path = `/_status`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates tags in the account
    * @summary Create activity tags
    * @param {TagPostRequest} body Publication POST request object
    * @throws {RequiredError}
    */
    createTags(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createTags.');
        }
        const path = `/tags`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete tag by tag name in the account
    * @param {string} tagId
    * @throws {RequiredError}
    */
    deleteTagById(params) {
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling deleteTagById.');
        }
        const path = `/tags/{tagId}`
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets all activity tags for the account
    * @summary Get all activity tags
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @throws {RequiredError}
    */
    getAllTags(params) {
        const path = `/tags`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get tag information by tag name in the account
    * @param {string} tagId
    * @throws {RequiredError}
    */
    getTagById(params) {
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling getTagById.');
        }
        const path = `/tags/{tagId}`
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update tag information by tag name in the account
    * @param {string} tagId
    * @param {TagPutRequest} body Tag PUT request object
    * @throws {RequiredError}
    */
    updateTagById(params) {
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling updateTagById.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateTagById.');
        }
        const path = `/tags/{tagId}`
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Run an activity by creating a worker
    * @summary Runs a worker by an activity Id for a specific accoun
    * @param {string} accountId
    * @param {string} activityId
    * @param {WorkerPostRequest} body Worker post request object
    * @throws {RequiredError}
    */
    runWorkerExternalByAccountAndActivityId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling runWorkerExternalByAccountAndActivityId.');
        }
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling runWorkerExternalByAccountAndActivityId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling runWorkerExternalByAccountAndActivityId.');
        }
        const path = `/webhooks/accounts/{accountId}/activities/{activityId}/workers`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'activityId'}}`, String(params.activityId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides access to a running worker for a given activity id and worker id. Returns a worker instance
    * @summary Get an instance of a worker by its activity and worker id
    * @param {string} activityId
    * @param {string} workerId
    * @throws {RequiredError}
    */
    getWorkerByActivityIdAndWorkerId(params) {
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling getWorkerByActivityIdAndWorkerId.');
        }
        // verify required parameter 'workerId' is not null or undefined
        if (params.workerId === null || params.workerId === undefined) {
            throw new utils_1.RequiredError('workerId', 'Required parameter workerId was null or undefined when calling getWorkerByActivityIdAndWorkerId.');
        }
        const path = `/activities/{activityId}/workers/{workerId}`
            .replace(`{${'activityId'}}`, String(params.activityId))
            .replace(`{${'workerId'}}`, String(params.workerId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Control worker state by issuing an appropriate action to take on the worker with the provided acitivty and worker id.
    * @summary Control worker state by its worker and activity ids
    * @param {string} activityId
    * @param {string} workerId
    * @param {WorkerPostResumeRequest} body
    * @throws {RequiredError}
    */
    resumeWorkerByActivityAndWorkerId(params) {
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling resumeWorkerByActivityAndWorkerId.');
        }
        // verify required parameter 'workerId' is not null or undefined
        if (params.workerId === null || params.workerId === undefined) {
            throw new utils_1.RequiredError('workerId', 'Required parameter workerId was null or undefined when calling resumeWorkerByActivityAndWorkerId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling resumeWorkerByActivityAndWorkerId.');
        }
        const path = `/activities/{activityId}/workers/{workerId}`
            .replace(`{${'activityId'}}`, String(params.activityId))
            .replace(`{${'workerId'}}`, String(params.workerId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Terminates a running worker
    * @summary Terminate a running worker
    * @param {string} activityId
    * @param {string} workerId
    * @throws {RequiredError}
    */
    terminateWorkerByWorkerAndActivityId(params) {
        // verify required parameter 'activityId' is not null or undefined
        if (params.activityId === null || params.activityId === undefined) {
            throw new utils_1.RequiredError('activityId', 'Required parameter activityId was null or undefined when calling terminateWorkerByWorkerAndActivityId.');
        }
        // verify required parameter 'workerId' is not null or undefined
        if (params.workerId === null || params.workerId === undefined) {
            throw new utils_1.RequiredError('workerId', 'Required parameter workerId was null or undefined when calling terminateWorkerByWorkerAndActivityId.');
        }
        const path = `/activities/{activityId}/workers/{workerId}`
            .replace(`{${'activityId'}}`, String(params.activityId))
            .replace(`{${'workerId'}}`, String(params.workerId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
}
exports.WorkflowService = WorkflowService;
